import HStack from "@ui-kit/layout/Stack/HStack.web";
import Button from "@ui-kit/form/Button/Button.web";
import Icon from "@ui-kit/icons/Icon.web";
import Box from "@ui-kit/layout/Box/Box.web";

import { useRouter } from "next/router";
import { useTranslation } from "@shared/utils/internationalization";
import useRedirect from "@shared/hooks/useRedirect.web";
import { CheckoutButtonProps } from "./CheckoutButton.props";

export default function CheckoutButton(props: CheckoutButtonProps) {
  const {
    shouldCheckout,
    checkoutUrl,
    isDisabled,
    isLoading,
    onCheckout,
    quantityToDisplay,
    customVerbiage,
  } = props;

  const { t } = useTranslation("box-office");
  const router = useRouter();
  const { redirect } = useRedirect();
  const buttonText =
    customVerbiage ||
    (shouldCheckout ? t("Process Transaction") : t("Continue"));

  return (
    <Button
      flexGrow={1}
      variant="solid"
      onClick={() => {
        // need to redirect first, because shouldCheckout is only true when on the /checkout/ route
        // add query params to maintain exchange context
        if (checkoutUrl) {
          redirect(
            { pathname: checkoutUrl, query: router.query },
            { as: checkoutUrl }
          );
        }
        onCheckout();
      }}
      isLoading={isLoading}
      isDisabled={isDisabled}
      data-testid={`checkout-${shouldCheckout ? "process" : "continue"}-button`}
    >
      <Box as="span">{buttonText}</Box>

      {!shouldCheckout && quantityToDisplay > 0 ? (
        <HStack spacing="2" align="center" justifyContent="center">
          <Box as="span" />
          <Box as="span">|</Box>
          <Icon.Cart.Outline
            h="element.lg"
            w="element.lg"
            colorPalette="currentColor"
          />
          <Box as="span" data-testid="checkout-button-quantity">
            {quantityToDisplay}
          </Box>
        </HStack>
      ) : null}
    </Button>
  );
}
